import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { useTheme } from '../../context/ThemeContext';
import { Home, ArrowLeft, Shield } from 'lucide-react';

export default function NotFoundPage() {
  const { isDark } = useTheme();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-background">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <Shield className="w-10 h-10 text-primary" />
        </div>
        
        <h1 className="font-secondary font-bold text-6xl mb-4">404</h1>
        <h2 className="font-secondary text-2xl mb-2">Page Not Found</h2>
        <p className="text-muted-foreground mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild variant="outline">
            <Link to="/">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Link>
          </Button>
          <Button asChild>
            <Link to="/dashboard">
              <Home className="w-4 h-4 mr-2" />
              Dashboard
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
